var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data.blogSeiteData)?_c('page',{key:_vm.data.blogSeiteData.id,attrs:{"data":_vm.data.blogSeiteData,"breakBlockData":_vm.data.breakBlockData,"newDesign":_vm.data.blogSeiteData.attributes.new_design}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }